import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { getInventarioCliente } from "../../services/api_inventario_cliente";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Dashboard = () => {
  const [ordensAbertasAtrasadas, setOrdensAbertasAtrasadas] = useState(0);
  const [ordensAbertasEmDia, setOrdensAbertasEmDia] = useState(0);
  const [ordensFechadasEmDia, setOrdensFechadasEmDia] = useState(0);
  const [ordensFechadasAtrasadas, setOrdensFechadasAtrasadas] = useState(0);
  const [equipamentosAtivos, setEquipamentosAtivos] = useState(0);
  const [ordensAbertas, setOrdensAbertas] = useState(0);
  const [ordensFechadas, setOrdensFechadas] = useState(0);
  const [ordensCanceladas, setOrdensCanceladas] = useState(0);
  const [isLoading, setLoading] = useState(false);

  const chartRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const idUnidade = localStorage.getItem("idUnidade");
      let body = {
        idUnidade: idUnidade
      };
      if (body) {
        try {
          //console.log("Fetching data for unidade ID:", idUnidade);
          const response = await getInventarioCliente(body);
          //console.log("Response received:", response);

          const {
            qtdeOrdensAbertasAtrasadas,
            qtdeOrdensAbertasEmDia,
            qtdeOrdensFechadasAtrasadas,
            qtdeOrdensFechadasEmDia,
            totalOrdensAbertas,
            totalOrdensFechadas,
            qtdeEquipamentosAtivos,
            totalOrdensCanceladas,
          } = response.data.relatorio;

          setEquipamentosAtivos(qtdeEquipamentosAtivos);
          setOrdensAbertas(totalOrdensAbertas);
          setOrdensFechadas(totalOrdensFechadas);
          setOrdensAbertasAtrasadas(qtdeOrdensAbertasAtrasadas);
          setOrdensAbertasEmDia(qtdeOrdensAbertasEmDia);
          setOrdensFechadasEmDia(qtdeOrdensFechadasEmDia);
          setOrdensFechadasAtrasadas(qtdeOrdensFechadasAtrasadas);
          setOrdensCanceladas(totalOrdensCanceladas);
          setLoading(false);
        } catch (error) {
          console.error("Erro ao obter informações do inventário da unidade:", error);
          setLoading(false);
        }
      } else {
        console.warn("User unidade ID is missing in localStorage");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const chartData = {
    labels: ['Ordens Abertas', 'Ordens Fechadas', 'Ordens Canceladas', 'Equipamentos Ativos'],
    datasets: [
      {
        label: `Ordens Abertas em Atraso - ${ordensAbertasAtrasadas}`,
        data: [ordensAbertasAtrasadas, 0, 0, 0],
        backgroundColor: 'rgba(255, 99, 132, 0.8)',
        borderColor: 'rgba(255, 99, 132, 1)',
      },
      {
        label: `Ordens Abertas em Dia - ${ordensAbertasEmDia}`,
        data: [ordensAbertasEmDia, 0, 0, 0],
        backgroundColor: 'rgba(255, 206, 86, 0.8)',
        borderColor: 'rgba(255, 206, 86, 1)',
      },
      {
        label: `Ordens Fechadas em Atraso - ${ordensFechadasAtrasadas}`,
        data: [0, ordensFechadasAtrasadas, 0, 0],
        backgroundColor: 'rgba(75, 192, 192, 0.8)',
        borderColor: 'rgba(75, 192, 192, 1)',
      },
      {
        label: `Ordens Fechadas em Dia - ${ordensFechadasEmDia}`,
        data: [0, ordensFechadasEmDia, 0, 0],
        backgroundColor: 'rgba(54, 162, 235, 0.8)',
        borderColor: 'rgba(54, 162, 235, 1)',
      },
      {
        label: `Ordens Canceladas - ${ordensCanceladas}`,
        data: [0, 0, ordensCanceladas, 0],
        backgroundColor: 'rgba(153, 102, 255, 0.8)',
        borderColor: 'rgba(153, 102, 255, 1)',
      },
      {
        label: `Equipamentos Ativos - ${equipamentosAtivos}`,
        data: [0, 0, 0, equipamentosAtivos],
        backgroundColor: 'rgba(255, 159, 64, 0.8)',
        borderColor: 'rgba(255, 159, 64, 1)',
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: `Ordens de Serviço`,
      },
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
  };

  return (
    <div className="content-wrapper pl-3 pr-3 pt-2">
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "700px" }}>
          <Spinner animation="border" variant="dark" />
        </div>
      ) : (
        <Container fluid>
          <Row className="justify-content-center">
            <Col lg={10} md={12} xs={12} className="mb-4 bg-light border border-white rounded-4 shadow-sm">
              <div className="d-flex justify-content-center" style={{ width: '100%', height: '600px', marginTop: '20px' }}>
                <Bar ref={chartRef} data={chartData} options={chartOptions} />
              </div>
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
};

export default Dashboard;
